import { Dispatch, SetStateAction, createContext } from "react";

import { ValuePartExchangeFormState } from "features/vehicleDetails/modals/ValuePartExchangeForm";
import { PartExchangeModalContentResponse } from "pages/api/part-exchange-modal-content";
import { PartExchange } from "services/motorpoint/partExchange";
import {
    PartExchangeQuestionAnswers,
    PartExchangeQuestionAnswersResponse,
    PartExchangeQuestions,
} from "services/motorpoint/partExchangeQuestions";

import usePartExchangeData from "./usePartExchangeData";
import usePartExchangeQuestions from "./usePartExchangeQuestions";

type PartExchangeQuestionsProviderContextProps = {
    partExQuestions: PartExchangeQuestions.Questions | undefined;
    partExQuestionsVehicle: PartExchangeQuestions.CapValuation | undefined;
    formAnswers: PartExchangeQuestionAnswers.Answers | undefined;
    tooUnique: PartExchangeQuestions.TooUnique | undefined;
    partExQuestionsAnswersResponse:
        | PartExchangeQuestionAnswersResponse.AnswersResponse
        | PartExchange
        | undefined;
    modalContent: PartExchangeModalContentResponse | undefined;
    setGetModalContentData: Dispatch<SetStateAction<boolean>>;
    resetAllQuestionsData(): void;
    postPartExAnswers(
        answers: PartExchangeQuestionAnswers.Answers
    ): Promise<PartExchangeQuestionAnswersResponse.AnswersResponse | undefined>;
    updateFormAnswers(
        section: "UserAnswers" | "PersonalDetailsModel",
        answers:
            | Partial<PartExchangeQuestionAnswers.PersonalDetailsModel>
            | Partial<PartExchangeQuestionAnswers.UserAnswers>
            | Record<string, string>
            | unknown
    ): PartExchangeQuestionAnswers.Answers;
    getPartExQuestions: (
        mileageReg: ValuePartExchangeFormState
    ) => Promise<PartExchangeQuestions.Questions | undefined>;
} | null;

export type PartExchangeQuestionsProviderProps = {
    children: React.ReactNode;
};

export const PartExchangeQuestionsProviderContext =
    createContext<PartExchangeQuestionsProviderContextProps>(null);

const PartExchangeQuestionsProvider = ({ children }: PartExchangeQuestionsProviderProps) => {
    const { partExchangeData, setPartExchangeData, resetPartExchangeData } = usePartExchangeData();
    const {
        getPartExQuestions,
        postPartExAnswers,
        updateFormAnswers,
        resetAllQuestionsData,
        setGetModalContentData,
        partExQuestions,
        modalContent,
        partExQuestionsVehicle,
        tooUnique,
        formAnswers,
    } = usePartExchangeQuestions(setPartExchangeData, resetPartExchangeData);

    return (
        <PartExchangeQuestionsProviderContext.Provider
            value={{
                postPartExAnswers,
                getPartExQuestions,
                updateFormAnswers,
                resetAllQuestionsData,
                setGetModalContentData,
                partExQuestions,
                partExQuestionsVehicle,
                partExQuestionsAnswersResponse: partExchangeData,
                formAnswers,
                tooUnique,
                modalContent,
            }}
        >
            {children}
        </PartExchangeQuestionsProviderContext.Provider>
    );
};

export default PartExchangeQuestionsProvider;
